<template>
    <div id="map" style="width: 100%; height: 100%" class="light">
      <div
        id="mapContainer"
        style="width: 100%; height: 100%"
        ref="hereMap"
      ></div>
    </div>
    <!-- <div v-else>
      <span class="no-location-text">Location Not Available</span>
    </div> -->
  <!-- </div> -->
</template>

<script>
import TruckIcon from "@common/asset/images/truck.svg";
export default {
  name: "HereMap",
  data() {
    const mapData = this.$session.get('mapData');
    const paths = mapData && mapData.locations ?  mapData.locations.map((path) => {
      const position = {
        lat: path.loc[0],
        lng: path.loc[1],
        createdAt: path.createdAt,
      };
      return position;
    }) : [];
    const drops = mapData && mapData.trip
      ? mapData.trip.drops.map((drop, index) => {
          const position = { lat: drop.loc[0], lng: drop.loc[1] };
          return {
            index: paths.length + index,
            position,
            lat: drop.loc[0],
            lng: drop.loc[1],
            type: "drop",
            name: drop.name,
          };
        })
      : [];
    const location = paths && paths.length > 0 ? paths[0] : null;
    return {
      center: paths[0],
      isEmpty: location === null || drops === null,
      platform: "web",
      drops,
      paths,
      location,
      markers: [
        {
          position: location,
          truckIcon: true,
          curr_ETA: mapData.trip ? mapData.trip.curr_ETA : null,
          truck_number: mapData.trip ? mapData.trip.truck_number : null,
        },
      ],
      defaultZoom: mapData && mapData.mapSettings && mapData.mapSettings.hmap_zoom,
    };
  },
  async mounted() {
    const platform = new H.service.Platform({
      apikey: this.$route.query.apiKey,
    });
    this.platform = platform;
    this.initializeHereMap();
  },
  methods: {
    dateFormat(date) {
      return `${date.toDateString()} ${date.toLocaleTimeString()}`;
    },
    addPolylineToMap() {
      var lineString = new H.geo.LineString();
      this.paths.forEach((_location) => {
        lineString.pushPoint(_location);
      });
      this.map.addObject(
        new H.map.Polyline(lineString, { style: { lineWidth: 4 } })
      );
    },
    plotMarker(group, locations, isDrop = false, html) {
      const icon = new H.map.Icon(TruckIcon);
      locations.forEach((_location) => {
        const option = {
          icon: _location.truckIcon ? icon : null,
        };
        let marker = new H.map.Marker(_location.position, option);
        const currentETA = marker.curr_ETA
          ? this.dateFormat(new Date(marker.curr_ETA))
          : "-";
        const lastSeen = new Date(_location.position.createdAt);
        let Html = {
          position: _location.position,
          html: `<div class="bubble"><b>Truck no:</b> ${
            _location.truck_number
          } <br/> <b>ETA:</b> ${currentETA} <br/>  <b>Last seen:</b> ${this.dateFormat(
            lastSeen
          )}</div>`,
        };
        if (isDrop) {
          Html = {
            position: _location.position,
            html: `<b>${_location.name}</b>`,
          };
        }
        marker.setData(Html);
        group.addObject(marker);
      });
    },
    initializeHereMap() {
      // rendering map
      // Obtain the default map types from the platform object
      const maptypes = this.platform.createDefaultLayers();
      // Instantiate (and display) a map object:
      const mapContainer = this.$refs.hereMap;

      this.map = new H.Map(mapContainer, maptypes.vector.normal.map, {
        zoom: this.defaultZoom,
        center: this.center,
        pixelRatio: window.devicePixelRatio || 1,
      });
      new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
      // add a resize listener to make sure that the map occupies the whole container
      // window.addEventListener('resize', () => map.getViewPort().resize())
      var group = new H.map.Group();

      this.map.addObject(group);

      // add UI
      var ui = H.ui.UI.createDefault(this.map, maptypes);
      ui.removeControl("mapsettings"); //removing setting for here map
      ui.removeControl("scalebar"); //removing scalebar
      group.addEventListener(
        "tap",
        function (evt) {
          ui.getBubbles().forEach((bub) => ui.removeBubble(bub));
          if (!evt.target.getData) return;
          // for all objects that it contains
          const data = evt.target.getData();
          var bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
            // read custom data
            content: data.html,
          });
          this.center = data.position;
          this.map.setCenter(this.center);
          // show info bubble
          ui.addBubble(bubble);
        }.bind(this)
      );
      // End rendering the initial map
      this.addPolylineToMap();
      this.plotMarker(group, this.markers);
      this.plotMarker(group, this.drops, true);
      this.map.setZoom(this.defaultZoom);
    },
  },
};
</script>

<style lang="scss">
// .no-location-text {
//   color: #6D8EB4;
//   display: inline-block;
//   margin-left: 20px;
//   font-size: 18px;
//   font-weight: 300;
// }
.H_ui {
  .H_ib_body {
    .H_ib_close.H_btn {
      width: 20px;
    }
  }
}
</style>
